import { render, staticRenderFns } from "./page-affirmation.vue?vue&type=template&id=5e34306c&"
import script from "./page-affirmation.vue?vue&type=script&lang=ts&"
export * from "./page-affirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports